import { AppInfo } from '../environment';

// const base_url = () => 'http://localhost:3000';

const base_url = () => AppInfo.Environment.api;

const base_url_MA = () => AppInfo.Environment.myAccountAPI;

const base_url_customer_support = () => AppInfo.Environment.customerSupportAPI;

export const ApiRouter = {
  getPlanDetails: (planNumber: string) => {
    return `${base_url()}/api/v1/plan-details/${planNumber}`;
  },
  getPlanClaims: (planNumber: string) => {
    return `${base_url()}/api/v1/plan-details/${planNumber}/claims`;
  },
  getPlanRepair: (planNumber: string) => {
    return `${base_url()}/api/v1/plan-details/${planNumber}/repair`;
  },
  getPlanHistory: (planNumber: string) => {
    return `${base_url()}/api/v1/plan-details/${planNumber}/history`;
  },
  cancelClaim: (planNumber: string, claimId: string, rms: 'ORBIT' | 'BRIGHT') => {
    return `${base_url()}/api/v1/plan-details/${planNumber}/claims/${claimId}/cancel?RMS=${rms}`;
  },
  getRebookingAppointments: (planNumber: string, claimId: string) => {
    return `${base_url()}/api/v1/claim-details/${planNumber}/${claimId}/rebook-appointments`;
  },
  rebookAppointment: (planNumber: string, claimId: string) => {
    return `${base_url()}/api/v1/claim-details/${planNumber}/${claimId}/rebook-appointments`;
  },
  visitAppointments: (planNumber: string, claimId: string) => {
    return `${base_url()}/api/v1/claim-details/${planNumber}/${claimId}/visit-appointments`;
  },
  submitFeedback: () => {
    return `${base_url()}/api/v1/feedback`;
  },
  startClaim: (planNumber: string) => {
    return `${base_url()}/api/v1/plan-details/${planNumber}/start-claim`;
  },
  resumeClaim: (planNumber: string) => {
    return `${base_url()}/api/v1/plan-details/${planNumber}/resume-claim`;
  },
  searchPlanDocumentKey: () => {
    return `${base_url_MA()}/search-plan-document`;
  },
  downloadPlanDocument: (planNumber: string, encodeKey: any, encodeHash: any) => {
    return `${base_url_MA()}/plans/${planNumber}/plan-document/download?key=${encodeKey}&hash=${encodeHash}`;
  },
  lookupOptions: (planNumber: string, claimId: string, option: string) => {
    return `${base_url()}/api/v1/plan-details/${planNumber}/claims/${claimId}/lookup/${option}`;
  },
  submitStep: (planNumber: string, claimId: string, step: string) => {
    return `${base_url()}/api/v1/plan-details/${planNumber}/claims/${claimId}/submit/${step}`;
  },
  rebooking: (planNumber: string, claimID: string) => {
    return `${base_url()}/api/v1/plan-details/${planNumber}/claims/${claimID}/rebooking`;
  },
  getRepairData: (planNumber: string, claimID: string) => {
    return `${base_url()}/api/v1/plan-details/${planNumber}/claims/${claimID}`;
  },
  orbit: {
    bvModelNumberLookup: () => {
      return `${base_url()}/api/v1/model-number-lookup`;
    },
    formStepEndpoint: (step: string) => {
      return `${base_url()}/api/v1/orbit/${step}`;
    },
    paymentRedirect: () => {
      return `${base_url()}/api/v1/orbit/payment-redirect`;
    },
    makePayment: () => {
      return `${base_url()}/api/v1/orbit/payment`;
    },
    startClaim: () => {
      return `${base_url()}/api/v1/orbit/start-claim`;
    },
    getBundle: () => {
      return `${base_url()}/api/v1/orbit/inspect-bundle`;
    },
    freeTextSearch: () => {
      return `${base_url()}/api/v1/orbit/free-text-search`;
    },
    vcCapture: () => {
      return `${base_url()}/api/v1/notification`;
    },
    customerSupportVcCapture: () => {
      return `${base_url_customer_support()}/api/v1/notification`;
    },
    getRepairData: (claimID: string, decrypt = true) => {
      return `${base_url()}/api/v1/orbit/repair-data?claimID=${claimID}&decrypt=${decrypt}`;
    },
    getRebookingData: (claimID: string) => {
      return `${base_url()}/api/v1/orbit/rebooking/${claimID}`;
    },
    putRebookingData: () => {
      return `${base_url()}/api/v1/orbit/rebooking`;
    },
  },
};
